import React from 'react';
import {Link, NavLink, Outlet, useNavigate} from 'react-router-dom';
import {useAuth} from '../providers/AuthProvider';
import { LanguageSelector } from '../../features/shared/ui/LanguageSelector';
import { useTranslation } from 'react-i18next';
import Footer from '../../features/public/footer/Footer';
import { useSiteConfig } from '../providers/SiteConfigProvider'; // Importar useSiteConfig

export function AdminLayout() {
    const { t } = useTranslation();
    const auth = useAuth();
    const nav = useNavigate();
    const getNavClassName = ({isActive}: { isActive: boolean }) => (isActive ? 'navItem active' : 'navItem');
    const { config } = useSiteConfig();

    return (
        <div className="adminShell">
            <header className="adminTopbar">
                <div className="adminTopbarLeft">
                    <div className="brandBlock">
                        <Link to="/administracion/proyectos" className="brandLogoLink">
                            <img 
                                src={config.logoNavbar}
                                alt="Logo Almassora" 
                                className="brandLogo"
                            />
                        </Link>
                        <div className="brandText">
                            <Link to="/administracion/proyectos" className="brand">
                                {t('adminLayout.title')}
                            </Link>
                        </div>
                    </div>
                    <nav className="adminTopbarNav">
                        <NavLink to="/administracion/proyectos" className={getNavClassName}>
                            {t('adminLayout.projects')}
                        </NavLink>
                        {auth.isAdmin ? (
                            <>
                                <NavLink to="/administracion/usuarios" className={getNavClassName}>
                                    {t('adminLayout.users')}
                                </NavLink>
                                <NavLink to="/administracion/configuracion" className={getNavClassName}>
                                    Configuración
                                </NavLink>
                            </>
                        ) : null}
                        <NavLink to="/administracion/endpoints" className={getNavClassName}>
                            {t('adminLayout.endpoints')}
                        </NavLink>
                    </nav>
                </div>
                <div className="adminTopbarRight">
                    <LanguageSelector />
                    {auth.usuario ? (
                        <div className="muted">
                            {auth.usuario.nombreUsuario} · <strong>{t(auth.isAdmin ? 'adminUsersPage.adminRole' : 'adminUsersPage.readerRole')}</strong>
                        </div>
                    ) : null}
                    {auth.isAuthenticated ? (
                        <button
                            className="btn btnSecondary"
                            onClick={() => {
                                auth.logout();
                                nav('/administracion/iniciar-sesion', {replace: true});
                            }}
                            type="button"
                        >
                            {t('adminLayout.logout')}
                        </button>
                    ) : (
                        <Link className="btn btnPrimary" to="/administracion/iniciar-sesion">
                            {t('adminLayout.login')}
                        </Link>
                    )}
                </div>
            </header>
            <main className="adminMain appMainAdmin adminMainWide">
                <Outlet/>
            </main>
            <Footer />
        </div>
    );
}
